function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.349,
    height: 46.128,
    viewBox: "0 0 45.349 46.128",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2371"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 80",
    d: "M22.675 45.349A22.675 22.675 0 0 1 0 22.675a22.675 22.675 0 0 1 45.349 0 22.674 22.674 0 0 1-22.674 22.674",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 81",
    d: "M63.5 74.3H49.135a3.474 3.474 0 0 1-3.474-3.474v-6.21a3.474 3.474 0 0 1 3.474-3.474H63.5a3.474 3.474 0 0 1 3.474 3.474v6.213A3.474 3.474 0 0 1 63.5 74.3",
    transform: "translate(-33.642 -45.048)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 82",
    d: "m81.166 77.2-5.532-3.194V80.4z",
    transform: "translate(-55.726 -54.529)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 88",
    transform: "translate(0 .778)",
    style: {
      fill: "none"
    },
    d: "M0 0h45.349v45.349H0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-youtube.c509e74cf4e68079f1f0c44f5927ff58.svg";